'use strict';

$(document).ready(function () {
    var bgImgInputDesk = $('.bg-desk-img-for-page');
    var bgImgInputMob = $('.bg-mobile-img-for-page');

    if (bgImgInputDesk.length > 0) {
        var imageUrlDesk = bgImgInputDesk.val();

        $('.for-bg-image').addClass('active-bg');
        $('.active-bg').css('background-image', 'url(' + imageUrlDesk + ')');

        if (bgImgInputMob.length > 0 && $(window).width() <= 1024) {
            var imageUrlMob = bgImgInputMob.val();
            $('.active-bg').css('background-image', 'url(' + imageUrlMob + ')');
        }
    }
});
